import { bidiLine } from '@/lib/bidi';
/** Text whose lines may be Arabic or English: each line takes its own direction, so a
 *  script that mixes both reads right in both (one dir="auto" on the whole block makes
 *  every line follow the first one). */
export default function Lines({ text, className, lineClassName }: { text: string; className?: string; lineClassName?: string }) {
  return (
    <div className={className}>
      {text.split('\n').map((ln, i) => (ln.trim()
        ? <p key={i} dir="auto" className={lineClassName}>{bidiLine(ln)}</p>
        : <p key={i} aria-hidden="true" className={lineClassName}>&nbsp;</p>))}
    </div>
  );
}
